import apiFetch from '../apiFetch'

export default function (idRuta, token) {
  return apiFetch({endPoint: `Ruta/deleteRuta`, method: 'POST', body: {idRuta}, token: token})
}